import { Component, OnInit } from '@angular/core';
import { ExternalForgotPasswordService } from '@externalforgotpasswordservice/external-forgot-password.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-external-forgot-password',
  templateUrl: './external-forgot-password.component.html',
  styleUrls: ['./external-forgot-password.component.css'],
  providers: [ExternalForgotPasswordService],
})
export class ExternalForgotPasswordComponent implements OnInit {
  QuestionDetail: any = {};
  MailInvalid: boolean;
  QuestionInvalid: boolean;
  AnswerInvalid: boolean;
  QuestionEmpty: boolean;
  AnswerEmpty: boolean;
  UserDetails: any = {};
  Email: string;
  Question: any = {};
  Answer: string;
  emailPattern: string;
  MailPatternInvalid: boolean;
  FieldToggle: boolean;

  constructor(private forgotPasswordService: ExternalForgotPasswordService, private router: Router
    , private route: ActivatedRoute) {
    this.QuestionEmpty = false;
    this.AnswerEmpty = false;
    this.FieldToggle = true;
  }

  ngOnInit() {
    this.MailInvalid = false;
    this.QuestionInvalid = false;
    this.AnswerInvalid = false;
    this.GetQuestion();
    this.emailPattern = '^[A-Za-z0-9._%+-]{2,}@[a-zA-Z0-9]{1,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})$';
  }

  GetQuestion() {

    this.forgotPasswordService.GetQuestion().subscribe(
      response => { this.QuestionDetail = response; }
    );

  }

  onSubmit(myForm) {
debugger;
    this.QuestionEmpty = false;
    this.AnswerEmpty = false;

    if (this.Question.questionID === undefined) {
      this.QuestionEmpty = true;
    }

    if (this.Answer === undefined) {
      this.AnswerEmpty = true;
    }

    if (!this.MailPatternInvalid && !this.QuestionEmpty && !this.AnswerEmpty) {
      this.UserDetails.EmailID = this.Email;
      this.UserDetails.QuestionID = this.Question.questionID;
      this.UserDetails.Answer = this.Answer;
      this.forgotPasswordService.SubmitForgotPassword(this.UserDetails).subscribe(
        response => {
          // if (response.indexOf('E') > -1) {
          //   this.MailInvalid = true;
          // } else if (response.indexOf('Q') > -1) {
          //   this.QuestionInvalid = true;

          // } else if (response.indexOf('A') > -1) {
          //   this.AnswerInvalid = true;
          // } 
          // else {
          //   this.FieldToggle = false;
          //   setTimeout((router: Router) => {
          //     this.router.navigate(['Login']);
          //   }, 3000);  // After 3secs redirect to Login page
          // }
          this.FieldToggle = false;
            setTimeout((router: Router) => {
              this.router.navigate(['Login']);
            }, 3000);  // After 3secs redirect to Login page
        }
      );
    }
  }

  clearWrongEmailMsg() {
    this.MailInvalid = false;
    this.QuestionInvalid = false;
    this.AnswerInvalid = false;
  }
  clearWrongQuestionMsg() {
    this.QuestionInvalid = false;
    this.AnswerInvalid = false;
  }
  clearWrongAnswerMsg() {
    this.AnswerInvalid = false;
  }
  validateEmail(myform) {
    if (!myform.controls.Email.valid) {
      this.MailPatternInvalid = true;
    } else {
      this.MailPatternInvalid = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/external-forgot-password/external-forgot-password.component.ts